/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
// Must stay the first import: acknowledges the duplicated Bryntum Core bundle
// before any @bryntum/* module is evaluated.
import './bryntum-bundle-guard';
import Vue from "vue";
// @ts-ignore
let marque = window.marque || {};
// Set the frontend platform config object
let dealerkit = window.dealerkit || {};
dealerkit.ui_version = '90.1.0'; // x-release-please-version
require('./bootstrap');
require('./dynamic-components');
require('./static-components');
require('./grid-components');
import Filters from './filters';
import globalAxios from 'axios';
// @ts-ignore
import { BaseResource } from './classes/Api/Resource';
import VueRouter from 'vue-router';
// Sentry distributed traces
const sentryTraceMeta = document.querySelector('meta[name="sentry-trace"]');
const sentryBaggageMeta = document.querySelector('meta[name="baggage"]');
// Setup & set the Resources http client.
// @ts-ignore
let http = window.http = globalAxios;
http.defaults.headers.common['X-CSRF-TOKEN'] = marque.ui.csrfToken;
http.defaults.headers.common['X-API-TOKEN'] = marque.ui.apiToken;
http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
if (sentryTraceMeta && sentryBaggageMeta) {
    http.defaults.headers.common['sentry-trace'] = sentryTraceMeta.content;
    http.defaults.headers.common['baggage'] = sentryBaggageMeta.content;
}
BaseResource.setHttp(http);
BaseResource.setBaseUri(marque.ui.baseEndpoint = marque.ui.baseUrl + '/api');
// @ts-ignore
import store from './store';
// @ts-ignore
import routes from './routes';
import { buildUrl, getQueryVariable, goTo, navigateTo, openInNewTab, printElement, printElementViaCanvas, reload, routeIs, setUtilsBaseUrl } from "./utils";
import "./integrations/product-events-consumers";
setUtilsBaseUrl(marque.ui.baseUrl);
let config = {
    store,
    el: '#marqueUI',
    filters: Filters,
    created() {
        // @ts-ignore
        this.$store.commit('user/set', window.marque.ui.user);
        // @ts-ignore
        this.$store.commit('user/setAuthorisations', window.marque.ui.authorisations);
        // @ts-ignore
        window.Echo.private('Marque.Models.Account.' + window.marque.ui.account.id + '.User.' + window.marque.ui.user.id)
            // @ts-ignore
            .notification((notification) => {
            // @ts-ignore
            this.$emit('notification', notification);
        });
    },
    mounted() {
        document.body.className += ' vue-mounted';
        //if (!this.hasDataSources) {
        document.body.className += ' data-loaded';
        //}
        function updateCssViewportHeight() {
            document.documentElement.style.setProperty('--dk-viewport-height', `${window.innerHeight}px`);
        }
        window.addEventListener('resize', updateCssViewportHeight);
        updateCssViewportHeight();
    },
    computed: {
        /*hasDataSources() {
            return _.keys(JSON.parse(marque.ui.dataSources)).length > 0;
        },*/
        mainClassnames() {
            // @ts-ignore
            let additional = this.additionalMainClassnames.join(' ');
            //return this.hasDataSources && this.dataManager.isPendingRequest ? 'data-loading' + additional : additional;
            return '';
        },
        config() {
            // @ts-ignore
            return window.marque;
        },
    },
    data() {
        return {
            csrfToken: marque.ui.csrfToken,
            baseUrl: marque.ui.baseUrl,
            additionalMainClassnames: [],
        };
    },
    methods: {
        printElementViaCanvas,
        printElement,
        openInNewTab,
        buildUrl,
        reload,
        goTo,
        navigateTo,
        getQueryVariable,
        routeIs,
    },
};
const routablePaths = [
    '/jobs',
    '/inbox'
];
const currentPathIsRoutable = () => {
    for (let i in routablePaths) {
        if (window.location.pathname.indexOf(routablePaths[i]) > -1) {
            return true;
        }
    }
    return false;
};
if (currentPathIsRoutable()) {
    // @ts-ignore
    config.router = new VueRouter({
        mode: 'history',
        routes // short for `routes: routes`
    });
}
else if (window.location.pathname === '/') {
    // @ts-ignore
    window.location = '/dashboard';
}
// @ts-ignore
marque.ui.app = new Vue(config);
